import { DashboardService } from "./../../shared/service/dashboard.service";
import { logging } from "protractor";
import { Component, OnInit } from "@angular/core";
import { CustomerSettingService } from "src/app/shared/service/customer-setting.service";
import { parse } from "date-fns";
import {
  trigger,
  transition,
  query,
  style,
  animate,
  group,
} from "@angular/animations";
import { AgencyService, CommonService } from "src/app/shared";
import { NgxSpinnerService } from "ngx-spinner";
import { FormBuilder, FormGroup } from "@angular/forms";
declare var Swal: any;
declare var jquery: any;
declare var $: any;


@Component({
  selector: "app-list-checkin",
  templateUrl: "./list-checkin.component.html",
  styleUrls: ["./list-checkin.component.css"],

})


export class ListCheckinComponent implements OnInit {
  settings?: Array<any> = [];
  agencyList?: Array<any> = [];
  agencyName: string = "";
  agencyId: any;
  counter: number = 0;
  loading: boolean = true;
  foundData: boolean = true;
  message: string = "";
  lastUpdate: string = "";

  total_round_point: string = "0/0";
  total_round: string = "0/0";

  listRoundItem: any[];
  listGroupRoundItem: any[];
  noRound: string = "นอกแผน";

  slideTime: number = 8000;

  listAgencyLastupdate: AgencyLastUpage[] = [];

  selectedDate: string | null = null;
  options: any = {
    locale: { format: 'YYYY-MM-DD' },
    alwaysShowCalendars: false,
    singleDatePicker: true,
    startDate: new Date(),
  };
  public formGroup: FormGroup;
  private sel_aggent: any;

  isCustomer: boolean = false;
  loginAgentName: string = '';

  constructor(
    private customerSettingService: CustomerSettingService,
    private agencyService: AgencyService,
    private spinner: NgxSpinnerService,
    private dashboardService: DashboardService,
    private commonService: CommonService,
    private fb: FormBuilder
  ) {


    this.checkIsCustomer();

    this.getAgentcyList();
    const now = new Date();
    const buddhistYear = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0'); // Months are zero-based
    const day = String(now.getDate()).padStart(2, '0');

    this.selectedDate = `${buddhistYear}-${month}-${day}`;
    console.log(this.selectedDate);
    this.formGroup = fb.group({
      sel_aggent: [this.sel_aggent],
      expiry_date: this.selectedDate
    });

  }

  checkIsCustomer() {
    let role = localStorage.getItem('role');
    this.isCustomer = (role === 'CUSTOMER');

    if (!this.isCustomer && role === 'AGENCY') {
      this.loginAgentName = localStorage.getItem('agency_name');
    }
  }

  ngOnInit() {

  }

  onChangeAgent(value) {
    console.log(value);
    this.sel_aggent = value;
    this.agencyId = value;
    // this.loadRoundReport(true);
  }


  onRefresh() {
    console.log("Refresh :: " + this.formGroup.get('expiry_date'));
    let find = this.agencyList.filter(x => x.id == this.agencyId);
    if (find.length > 0) {
      this.agencyName = find[0].name;
    }
    this.loadRoundReport(true);
  }

  selectedDay(value: any, datepicker?: any) {
    let startDate = value.start._d;
    console.log(startDate);
    this.selectedDate = this.formatDateToString(startDate);
    console.log(this.selectedDate);
  }

  formatDateToString(date: Date): string {
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Months are 0-indexed
    const day = date.getDate().toString().padStart(2, '0');

    return `${year}-${month}-${day}`;
  }


  getCustomerSettings() {
    this.customerSettingService.get().subscribe((res) => {
      this.settings = res.data;
      localStorage.setItem("settings-dashboard", JSON.stringify(this.settings));

      let index = this.settings.findIndex(
        (item) => item.setting_key === "slide_delay"
      );
      if (index !== -1) {
        this.slideTime = parseInt(this.settings[index].setting_value) * 60 * 1000;
      }
      console.log("Slide Time ::" + this.slideTime);
    });
  }

  getAgentcyList() {
    this.spinner.show();
    this.agencyService.get().subscribe(
      (data) => {

        if (this.isCustomer) {
          this.agencyList = data;
          console.log('no default agent login customer');
        }
        else {
          this.agencyList = data.filter(x => x.name == this.loginAgentName);;
          let find = this.agencyList;
          if (find.length > 0) {
            this.agencyName = find[0].name;
            this.agencyId = find[0].id;
          }

          console.log('default agent id : ' + this.agencyId);
        }
        this.spinner.hide();

        if (this.agencyList.length > 0) {
          setTimeout(() => {
            this.formGroup.patchValue(
              {
                sel_aggent: this.agencyList[0].id
              }
            );
            this.agencyName = this.agencyList[0].name;
            this.agencyId = this.agencyList[0].id;
            this.loadRoundReport(true);
          }, 200);
        }
        this.loading = false;
      },
      (error) => {
        console.error(error);
        this.spinner.hide();
        this.loading = false;
      }
    );
  }

  loadRoundReport(refresh?: boolean) {
    console.log("Agency Id ::" + this.agencyId);
    console.log("date:: " + this.selectedDate);
    this.foundData = false;
    this.loadData();
  }

  loadData() {
    this.loading = true;
    this.dashboardService
      .getListRoundReport(this.selectedDate, parseInt(this.agencyId))
      .subscribe(
        (res) => {
          if (res.code == "success") {
            this.bindResponse(res);

          } else if (res.code === "not_found") {
            this.bindResponse(res);

          }
          this.loading = false;
        },
        (error) => {
          console.error(error);
          this.loading = false;
          this.failDialog(error);
        }
      );
  }

  bindResponse(res: any) {
    if (res.code == "success") {
      this.total_round_point = res.header.total_round_point;
      this.total_round = res.header.total_round;
      let round_item = Array.from(
        new Set(res.round_item.map((a) => a.round_name))
      );
      this.listRoundItem = round_item;
      const groupedByRoundName = res.round_item.reduce((acc, item) => {
        const key = item.round_name;
        if (!acc[key]) {
          acc[key] = [];
        }
        acc[key].push(item);
        return acc;
      }, {} as Record<string, typeof res.round_item>);
      this.listGroupRoundItem = groupedByRoundName;
      this.foundData = true;
    } else if (res.code === "not_found") {
      this.foundData = false;
      this.message = res.message;
    }
  }

  failDialog(msg) {
    Swal.fire({
      type: "error",
      title: "เกิดข้อผิดพลาด",
      text: msg,
    });
  }
}

interface AgencyLastUpage {
  id: number;
  lastupdate: Date;
  data: any;
}
